import { NavStep } from "../../shared-logic/utils/Navigation";

export const checkoutStepIsActive = (step: NavStep): boolean => {
    return step === NavStep.Buy || step === NavStep.Reserve || step === NavStep.Lease;
};
